<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    mobile-breakpoint="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    :expand-on-hover="expandOnHover"
    app
    height="100%"
    id="main-sidebar"
  >
    <v-list dense nav>
      <!---USer Area -->
      <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <!-- <img :src="avatar" /> -->
          <v-avatar color="primary" size="56">
            <span class="white--text">{{ avatar }}</span>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{
            userData.adminLogin ? userData.adminLogin.name : "User"
          }}</v-list-item-title>
          <!-- <v-list-item-subtitle class="caption"
            >Webdesigner</v-list-item-subtitle
          > -->
          <!-- {{ dealerSummaryReport["installation.total"] }} -->
        </v-list-item-content>
      </v-list-item>
      <!---USer Area -->
      <!-- {{  $store.getters.GET_COD_BADGE['cod']['COD_FOR_CONFIRMATION'] }} adasda -->
      <template v-for="(item, i) in items">
        <div
          :key="i"
          v-if="item.role.indexOf(userRole) !== -1 && getPermission(item.code)"
        >
          <v-list-item
            v-if="!item.submenu"
            :key="i"
            :to="`${$route.matched[0].path}/${item.to}`"
            :active-class="`success white--text`"
            exact
            link
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }} </v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>

          <v-list-group v-else :value="false" :prepend-icon="item.icon">
            <template v-slot:activator>
              <v-list-item-title> {{ item.title }}</v-list-item-title>
            </template>

            <template v-for="(sub, j) in item.submenu">
              <div :key="j" v-if="getPermission(sub.code)">
                <template v-if="!sub.data">
                  <v-list-item
                    link
                    :to="`${$route.matched[0].path}/${sub.to}`"
                    :active-class="`success white--text`"
                    exact
                    class="ml-5"
                  >
                    <v-list-item-title>{{ sub.title }}</v-list-item-title>
                    <v-list-item-icon>
                      <v-icon v-if="sub.icon">{{ sub.icon }}</v-icon>
                      <v-badge v-if="sub.badge" color="green" inline>
                        <span slot="badge" v-if="sub.badge.param">{{
                          GET_COD_BADGE[sub.badge.param][sub.badge.value]
                        }}</span>
                         <span slot="badge" v-else>{{
                          dealerSummaryReport[sub.badge.value.split(".")[0]]
                        }}</span>
                      </v-badge>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
                <template v-else>
                  <v-list-item
                    link
                    :to="`${$route.matched[0].path}/${sub.to}`"
                    :active-class="`success white--text`"
                    exact
                    class="ml-5"
                    v-if="sub.data.includes(getDashboardRole.code)"
                  >
                    <v-list-item-title>{{ sub.title }}</v-list-item-title>
                    <v-list-item-icon>
                      <v-icon v-if="sub.icon">{{ sub.icon }}</v-icon>
                      <v-badge v-if="sub.badge" color="green" inline>
                        <span slot="badge" v-if="sub.badge.param">{{
                          GET_COD_BADGE[sub.badge.param][sub.badge.value.split(".")[0]]
                        }}</span>
                         <span slot="badge" v-else>{{
                          dealerSummaryReport[sub.badge.value.split(".")[0]]
                        }}</span>
                      </v-badge>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </div>
            </template>
          </v-list-group>
        </div>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// import { mapState } from "vuex";
// import { Role } from "../../helpers/role";
import {
  AcquisitionMenu,
  InventoryMenu,
  ManagementMenu,
  DealerMenu,
  DealerRetailerMenu,
  ServiceProviderMenu,
  DistributorMenu,
  PDSMenu,
  FinanceMenu,
} from "./menus";

export default {
  name: "Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    avatar: "",

    // items should also declare in router under under index.js
    items: [
      // acquisition
      ...AcquisitionMenu,

      // inventory
      ...InventoryMenu,

      // management
      ...ManagementMenu,

      // dealer
      ...DealerMenu,

      // drs
      ...DealerRetailerMenu,

      // service provider
      ...ServiceProviderMenu,
      // service provider
      ...DistributorMenu,
      // PDS provider
      ...PDSMenu,
      ...FinanceMenu,
    ],
  }),

  created() {
    this.$store.dispatch('ADD_COD_BADGE')
  },

  methods: {
    getPermission(code) {
      const f = this.$store.getters.dashboardRole.permissions.filter((obj) => {
        if (obj.level && obj.level.includes("R")) {
          // console.log(obj.code.split(".").pop());
          if (obj.code.split(".").pop() === code) {
            return true;
          }
        }
      });
      // console.log(!!f.length, code);
      return !!f.length;
    },

    getPermission1() {
      const f = this.userData.adminLogin.roles[0].permissions.filter((obj) => {
        if (obj.level && obj.level.includes("R")) {
          // console.log(obj.code.split(".").pop());
          // if (obj.code.split(".")[2] === code) {
          return true;
          // }
        }
      });
      // return f.length;
      console.log(f);
    },
  },

  mounted() {
    // this.avatar = `https://ui-avatars.com/api/?name=${this.userData.adminLogin
    //   .name || "A".substring(0, 2).toUpperCase()}`;
    this.avatar = this.userData.adminLogin.name.substring(0, 2).toUpperCase();
  },

  computed: {
    // ...mapState({
    //   SidebarColor: (state) => state.SidebarDrawerModule.SidebarColor,
    //   SidebarBg: (state) => state.SidebarDrawerModule.SidebarBg,
    // }),

    SidebarColor() {
      return this.$store.getters.getSidebar.SidebarColor;
    },

    SidebarBg() {
      return this.$store.getters.getSidebar.SidebarBg;
    },

    Sidebar_drawer: {
      get() {
        return this.$store.getters.getSidebar.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      },
    },

    userData() {
      return this.$store.getters.userData;
    },

    userRole() {
      return this.$store.getters.userRole;
    },

    dealerSummaryReport() {
      return this.$store.getters.dealerSummaryReport;
    },

    GET_COD_BADGE() {
      return this.$store.getters.GET_COD_BADGE;
    },

    getDashboardRole() {
      return this.$store.getters.dashboardRole;
    },
  },

  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },

    "this.$route.path"(val) {
      console.log(val);
    },
  },
};
</script>

<style lang="scss" scoped>
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
    & .v-list-item__title {
      font-size: 0.9rem !important;
    }
  }
}

// .v-application--is-ltr .v-list-item__action:first-child,
// .v-application--is-ltr .v-list-item__icon:first-child {
//   margin-right: 0px;
// }
</style>

<style>
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 10px !important;
}
</style>
